// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"data-base"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M21 20H20.4863C19.2502 21.1648 15.9178 22 12 22C8.08221 22 4.74984 21.1648 3.51367 20H3V5C3 6.65685 7.02944 8 12 8C16.9706 8 21 6.65685 21 5V20Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M12 8C16.9706 8 21 6.65685 21 5C21 3.34315 16.9706 2 12 2C7.02944 2 3 3.34315 3 5C3 6.65685 7.02944 8 12 8Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M21 12C21 13.6569 16.9706 15 12 15C7.02944 15 3 13.6569 3 12M21 12V19C21 20.6569 16.9706 22 12 22C7.02944 22 3 20.6569 3 19V12M21 12V5M3 12V5M3 5C3 6.65685 7.02944 8 12 8C16.9706 8 21 6.65685 21 5M3 5C3 3.34315 7.02944 2 12 2C16.9706 2 21 3.34315 21 5","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-data-base')
export default class DataBaseIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'data-base',
    }
  }
}
